"use client";

import { getFilterValue, parseFilter } from "@shared/utils";
import { ComboboxOption, RadioGroup, RadioGroupItem } from "@ubud-ui/react-ui-kit";
import { useRouter, useSearchParams } from "next/navigation";
import qs from "qs";

const FILTER_KEY = "gender";

export function GenderFilter({ path }: { path: string }) {
  const router = useRouter();
  const searchParams = useSearchParams();

  const options: ComboboxOption[] = [
    { value: "10", label: "Laki - laki" },
    { value: "20", label: "Perempuan" },
  ];

  const handleFilter = (option: ComboboxOption) => {
    const paramsString = searchParams.toString();

    const value = {
      id: option.value,
      label: option.label,
    };

    const params = parseFilter(FILTER_KEY, value, qs.parse(paramsString));

    router.push(`${path}?${qs.stringify(params, { skipNulls: true })}`, {
      scroll: false,
    });
  };

  const getValue = (value?: string) => {
    const params = qs.parse(searchParams.toString());

    return getFilterValue(params, FILTER_KEY, value);
  };

  return (
    <>
      {options && options.length > 0 ? (
        <RadioGroup
          defaultValue={getValue()?.id}
          onValueChange={(value) => handleFilter(options.find((it) => it.value == value) as ComboboxOption)}
        >
          <div className="space-y-3 pb-2">
            {options.map((option, index) => {
              return (
                <div className="flex items-start gap-3" key={"gender-" + option.value + "-" + index}>
                  <RadioGroupItem className="mt-1" id={"gender-" + option.value + "-" + index} value={option.value.toString()} />
                  <label htmlFor={"gender-" + option.value + "-" + index}>{option.label}</label>
                </div>
              );
            })}
          </div>
        </RadioGroup>
      ) : (
        <div className="text-center font-bold pb-2">Jenis kelamin tidak ditemukan</div>
      )}
    </>
  );
}
